import type { Invoice } from "@freightsimple/generated-dashboard-openapi-client/models/Invoice";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

/**
 * The date an invoice should be filed under on the Invoices screen.
 *
 * The shipment's pickup date, not the date the invoice was raised. A refund or a late additional
 * charge for an August shipment is part of what that August move cost, so it belongs beside the
 * charge it adjusts - filing it under the month the paperwork happened to be cut split one
 * shipment's money across two months and left neither total answering "what did this cost me".
 *
 * The screen only ever hands this invoices whose shipment it has loaded - an invoice without one
 * renders no row, so it is filtered out before grouping rather than counted into a total no row
 * accounts for. The fallback to the invoice's own date is defensive, for a caller that hasn't
 * filtered: a wrong month beats throwing on a money screen.
 */
export function invoicesBillingMonthDate(
  invoice: Invoice,
  shipmentsById: Map<string, Shipment>,
): string {
  return (
    shipmentsById.get(invoice.shipmentId)?.pickupDate ?? invoice.invoiceDate
  );
}
